import { TimeSlots } from '../types'

export const DATE_FORMAT_LITE = 'yyyy-MM-dd'
export const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss'
export const READABLE_DATE_FORMAT = 'dd/MM/yyyy \'à\' HH:mm'
export const SLOT_FORMAT = 'HH:mm:ss'

type TimeSlotsClock = Record<TimeSlots, `${number}:${number}:${number}`[]>
export const TIME_SLOTS_CLOCK = {
  [TimeSlots.MATIN]: ['00:00:00', '11:59:59'],
  [TimeSlots.MIDI]: ['12:00:00', '13:59:59'],
  [TimeSlots.APRES_MIDI]: ['14:00:00', '23:59:59'],
} as TimeSlotsClock
